export const environment = {
  production: true,
  staging: false,
  apiUrl: 'https://dev-coe.digilabs.ai/backend',
  COE_URL: 'https://dev-coe.digilabs.ai',
  aiChatApiUrl: 'https://dev-coe-ai.digilabs.ai',
  careerGuidanceUrl: 'https://dev-cg.starsystems.in/',
  vivaquestUrl: 'https://app.vivaquest.in/',
  firebaseConfig: {
    apiKey: 'AIzaSyBoi17jrErlZ_drS4jMuFIsAY1dI57L5GQ',
    authDomain: 'coedigilabs-e524f.firebaseapp.com',
    projectId: 'coedigilabs-e524f',
    storageBucket: 'coedigilabs-e524f.firebasestorage.app',
    messagingSenderId: '804102560931',
    appId: '1:804102560931:web:5799c973f76010ab547316',
    measurementId: 'G-S1Z0F3F329',

  },
  firebaseVapidKey:
    'BKkF4ljPqyVti6fG5dfJcrLR-UwQBvpvxqYwNasIBY7TJHf35uU61NeESm3WaJ-weALvznBiZ7ezoVacoMSRDCw',
  WS_URL: 'wss://dev-coe.digilabs.ai/backend',

};

